import { render } from "./HeroiconsSolidCalculator.vue?vue&type=template&id=b39f9a9c"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCalculator.vue"]])

export default __exports__